import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import MuiTextField, {} from '@mui/material/TextField';
export const TextField = forwardRef(function TextField({ label, error, hint, id, size = 'medium', fullWidth = true, ...rest }, ref) {
    const autoId = useId();
    const fieldId = id ?? autoId;
    return (_jsx(MuiTextField, { ref: ref, id: fieldId, label: label, size: size, fullWidth: fullWidth, error: Boolean(error), helperText: error ?? hint, ...rest }));
});
//# sourceMappingURL=text-field.js.map